// extracted by mini-css-extract-plugin
export default {"container":"PostPage_container__HVX1s","content":"PostPage_content__gtuMr","event":"PostPage_event__8jTkX"};